import React from 'react';
import parser from 'html-react-parser'
import {withTranslation} from "react-i18next";

import './index.scss';


const ExecutiveSummary = ( { data, t } ) => {
    if (!data || !data.summary_text) {
        return null;
    }

    const sanitizedHTML = parser(data.summary_text);

    return (
        <div className="executive-summary">
            <div className="executive-summary__logo-title-col">
                <h1 className="executive-summary__title">{t("HOME.CARD_HEADERS.EXECUTIVE_SUMMARY.title")}</h1>
                <div className="executive-summary__logo">
                    {data.logo_url && <img src={data.logo_url} className="executive-summary__logo-img"/>}
                </div>
            </div>
            <div className="executive-summary__text-col">{sanitizedHTML}</div>
        </div>

    );

};

export default withTranslation()(ExecutiveSummary);
